<div class="flex-col privacy-policy-container">
  <div class="flex-row flex-justify-end flex-align-center">
    <button mat-button class="close-button" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <gb-privacy-policy></gb-privacy-policy>
</div>
